import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/guidanceSleep/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getListDiary = (current, size, params) => {
  return request({
    url: '/health/guidanceSleepDiary/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/guidanceSleep/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/guidanceSleep/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/guidanceSleep/submit',
    method: 'post',
    data: row
  })
}

